import * as get from 'lodash/get';
import * as uniq from 'lodash/uniq';

import { DataServiceOperator } from '../helpers';
import { StoreColumnExtractor } from './store-column-extractor';

export class OperatorExtractor implements StoreColumnExtractor {
	constructor(
		public readonly extractorOrValueA: StoreColumnExtractor | number,
		public readonly extractorOrValueB: StoreColumnExtractor | number,
		public readonly dataOperator: DataServiceOperator,
		public readonly defaultValue: number
	) { }

	/**
	 * extractor: Use to calculate data from 2 data point.
	 */
	public storeConfigDependencies(): any[] {
		if (typeof this.extractorOrValueA === 'number' && typeof this.extractorOrValueB !== 'number') {
			return this.extractorOrValueB.storeConfigDependencies();
		}
		if (typeof this.extractorOrValueA !== 'number' && typeof this.extractorOrValueB === 'number') {
			return this.extractorOrValueA.storeConfigDependencies();
		}
		if (typeof this.extractorOrValueA === 'number' && typeof this.extractorOrValueB === 'number') {
			return [];
		}
		return uniq([...(<StoreColumnExtractor>this.extractorOrValueA).storeConfigDependencies(), ...(<StoreColumnExtractor>this.extractorOrValueB).storeConfigDependencies()]);
	}
	public extractor(): (...storeData: any[]) => any {
		return (...storeData: any[]) => {
			let valueA, valueB: number;
			if (typeof this.extractorOrValueA !== 'number') {
				const storeDataIndex = this.storeConfigDependencies().findIndex(store => store === get((<StoreColumnExtractor>this.extractorOrValueA).storeConfigDependencies(), '[0]'));
				valueA = this.extractorOrValueA.extractor()(get(storeData, `[${storeDataIndex}]`));
			} else {
				valueA = this.extractorOrValueA;
			}
			if (typeof this.extractorOrValueB !== 'number') {
				const storeDataIndex = this.storeConfigDependencies().findIndex(store => store === get((<StoreColumnExtractor>this.extractorOrValueB).storeConfigDependencies(), '[0]'));
				valueB = this.extractorOrValueB.extractor()(get(storeData, `[${storeDataIndex}]`));
			} else {
				valueB = this.extractorOrValueB;
			}
			return this.dataOperator.calculate(valueA, valueB, this.defaultValue);
		};
	}

	public getDataPointPath(): string {
		let dataPath = '';

		dataPath += typeof this.extractorOrValueA !== 'number' ?
			`ValueA: ${(<StoreColumnExtractor>this.extractorOrValueA).getDataPointPath()}` :
			`ValueA: ${(this.extractorOrValueA)}`;
		dataPath += ', ';
		dataPath += typeof this.extractorOrValueB !== 'number' ?
			`ValueB: ${(<StoreColumnExtractor>this.extractorOrValueB).getDataPointPath()}` :
			`ValueB: ${(this.extractorOrValueB)}`;

		return dataPath;
	}
}
